import {useAxios} from "@vueuse/integrations/useAxios";
import {IGrade, IGetResult, ISubmitGradeRequest} from "@/types/api.ts";
import {axiosInstance} from "@/composables/axiosInstance.ts";
import {useFactoryFetch} from "@/composables/useFactoryFetch.ts";
import {AfterFetchContext} from "@vueuse/core";
import {API_URLS} from "@/utils/constants/api-urls.ts";

export class GradeService {

  static getInstance(): GradeService {
    return new GradeService();
  }

  async submitGrade(body: ISubmitGradeRequest): Promise<void> {
    const {execute, data} = useAxios<IGetResult>(API_URLS.grades.submit, {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data
  }

  viewGradesForCurrentStudent() {
    return useFactoryFetch(API_URLS.grades.gradesForCurrentUser, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.studentGrades}
      }
    }).json();
  }

  viewGradesForAllStudents() {
    return useFactoryFetch(API_URLS.grades.gradesForAllStudents, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.grades}
      }
    }).json();
  }

  async deleteGrade(grade: IGrade) {
    const {execute} = useAxios<IGetResult>(API_URLS.grades.deleteById(grade._id), {
      method: "DELETE",
    }, axiosInstance, {immediate: false})
    await execute();
  }
}